import { useEffect } from 'react';

export const ERROR_MESSAGE_DISPLAY_MS = 15 * 1000;

export function useAutoDismissMessage(message, setMessage, dismissMs = ERROR_MESSAGE_DISPLAY_MS) {
  useEffect(() => {
    if (!message) return undefined;
    const timer = setTimeout(() => setMessage(''), dismissMs);
    return () => clearTimeout(timer);
  }, [message, setMessage, dismissMs]);
}
